export const OFFER_FILTER_I18N = {
  en: {
    filterByProductLabel: 'Filter by product',
    resultsLabel: (filtered: number, total: number, result: string) => `Showing ${filtered} of ${total} ${result}`,
    showMoreLabel: 'Show more ',
    bundleLabel: 'Bundle',
    allLabel: 'All',
    noFoundTitleLabel: (result: string) => `We couldn't find any ${result} for your search`,
    noFoundLabel: 'Try modifying the applied filters',
  },
  fr: {
    filterByProductLabel: 'Filter par produit',
    resultsLabel: (filtered: number, total: number, result: string) => `${filtered} de ${total} ${result} affichés`,
    showMoreLabel: "Afficher plus d'",
    bundleLabel: 'Ensemble',
    allLabel: 'Tout afficher',
    noFoundTitleLabel: (result: string) => `Nous n'avons pas trouvé d'${result} correspondant à votre recherche`,
    noFoundLabel: 'Veuillez modifier les filtres appliqués',
  },
}
